/** Entry point: styles, data source (bootstrap.ts), query client, <App>. */
import "./styles.css";
import "@faylasuf/print/print.css"; // [C28] F-274: the print stylesheet ships with the bundle (CSP style-src 'self')
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./app/App.js";
import { bootstrap } from "./app/bootstrap.js";
import { createQueryClient } from "./app/query.js";
import { ErrorBoundary } from "./app/ErrorBoundary.js";
import { installGlobalHandlers, setTelemetryEnabled } from "./app/telemetry.js";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

bootstrap()
  .then((boot) => {
    // [C28] D-259: browser errors are reported to the platform logs (never in fixture mode).
    setTelemetryEnabled(boot.mode === "api");
    installGlobalHandlers();
    createRoot(root).render(
      <StrictMode>
        <ErrorBoundary fallback={(ref) => <RootCrash traceRef={ref} />}>
          <QueryClientProvider client={createQueryClient()}>
            <App boot={boot} />
          </QueryClientProvider>
        </ErrorBoundary>
      </StrictMode>,
    );
  })
  .catch((e: unknown) => {
    // Only the fixture selector can fail here (unknown name in DEV); production bootstrap has no async failure path.
    const pre = document.createElement("pre");
    pre.textContent = e instanceof Error ? e.message : String(e);
    root.replaceChildren(pre);
  });

/** [C28] Whole-app crash (outside the i18n provider): both languages, a reload button, the trace reference. */
function RootCrash({ traceRef }: { traceRef: string }) {
  return (
    <div dir="rtl" style={{ fontFamily: "Cairo, sans-serif", padding: 48, textAlign: "center" }}>
      <h1 style={{ fontWeight: 900, fontSize: 20, marginBottom: 8 }}>تعذّر تشغيل البرنامج · The program could not start</h1>
      <p style={{ fontSize: 14, marginBottom: 16 }}>
        رقم التتبع · Trace: <span dir="ltr" style={{ fontFamily: "monospace" }}>{traceRef}</span>
      </p>
      <button type="button" onClick={() => window.location.reload()} style={{ padding: "8px 24px", borderRadius: 12, fontWeight: 900 }}>
        إعادة التحميل · Reload
      </button>
    </div>
  );
}
